<template>
  <div class="baniere pt-6 pb-8">
    <div class="md:flex mt-20">
      <div class="bloc1 pt-4">
        <div class="md:w-full w-2/3">
          <divider
            :height="diviserHeight"
            :color="diviserColor"
            data-aos="fade-right"
            data-aos-duration="2000"
          />
        </div>
        <div
          class="titre w-full mt-5"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Fonctionnalités
        </div>
      </div>

      <div class="bloc2 md:pl-24">
        <mobile
          class="md:mt-0 mt-6"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <dashboard
          class="mt-16"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <Carousel
          ref="carousel5"
          :controls="false"
          :per-page="1"
          :loop="true"
          :pagination-enabled="false"
          :speed="1500"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <Slide
            v-for="(item, index) in allImage"
            :key="index"
          >
            <img
              :src="item"
              alt=""
              class="mt-12"
            >
          </Slide>
        </Carousel>

        <!--        <img-->
        <!--          src="../../../assets/images/jpg/ordinateur.jpg"-->
        <!--          alt=""-->
        <!--          class="mt-12"-->
        <!--        >-->
        <div
          class="flex justify-center mt-4"
        >
          <svg-icon
            name="ic_prev"
            class="md:h-10 h-6 cursor-pointer mr-4"
            original
            data-aos="fade-right"
            data-aos-duration="2000"
            @click="goToSlidePrev"
          />
          <svg-icon
            name="ic_next"
            class="md:h-10 h-6 cursor-pointer"
            original
            data-aos="fade-left"
            data-aos-duration="2000"
            @click="goToSlideNext"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'
import mobile from '@/components/cedo/assurance/mobile'
import dashboard from '@/components/cedo/assurance/dashboard'
import { Carousel, Slide } from 'vue-carousel'
import arsen from '../../../assets/images/webp/mac1.webp'
import arsen1 from '../../../assets/images/webp/mac2.webp'
import kalan from '../../../assets/images/webp/mac3.webp'

export default {
  name: 'Index',
  components: {
    divider,
    mobile,
    dashboard,
    Slide,
    Carousel
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#9FB4FE',
      diviserHeight: '5px',
      allImage: [arsen, kalan, arsen1]
    }
  },
  created () {
  },
  methods: {
    goToSlidePrev () {
      this.$refs.carousel5.goToPage(this.$refs.carousel5.getPreviousPage())
    },
    goToSlideNext () {
      this.$refs.carousel5.goToPage(this.$refs.carousel5.getNextPage())
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.baniere{
  height: auto ;
  background-color: $white;
  position: relative;
  padding-left: $padding-l;
  padding-right: $padding-r;
}
.bloc1{
  width: 32%;
}
.bloc2{
  width: 68%;
  font-weight: bold;
  font-size: 24px;
  line-height: 160%;
}

.titre{
  font-weight: 800;
  font-size: 40px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black
}
.svg-fill{
  fill: transparent;
}

@media screen and (max-width: 600px){
  .baniere{
    padding-left: 20px;
    padding-right: 20px;
  }
  .titre{
    font-size: 28px;
  }
  .bloc1{
    width: 100%;
  }
  .bloc2{
    width: 100%;
    font-size: 18px;
  }
  .titre1{
    font-size: 20px;
  }
  .title3{
    font-size: 18px;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .baniere{
    padding-left: $padding-l-1024;
    padding-right: $padding-r-1024;
  }
  .titre{
    font-size: 30px;
  }
  .title3{
    font-size: 22px;
  }
  .titre1{
    font-size: 20px;
  }

  .blocc {
    padding: 30px;
  }
}
</style>
